import { createGlobalStyle } from 'styled-components/macro';

import typography from './styled-typography';


const GlobalStyles = createGlobalStyle`
    html {
        font-size: ${(10 / 1920) * 100}vw;
    }
    
    html,
    body {
        width: 100%;
        height: 100%;
    }
    
    a {
        text-decoration: none;
        transition: 250ms all;
    }
    
    ${typography};
`;


export default GlobalStyles;
